export default class Jockey {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.jockey = {
      translations: [
        { id: null, name: '', lang: 'ar' },
        { id: null, name: '', lang: 'en' }
      ]
    }
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.jockey.translations[0].id = itemAr ? itemAr.id : null
      this.jockey.translations[0].name = itemAr ? itemAr.name : ''
      this.jockey.translations[1].id = itemEn ? itemEn.id : null
      this.jockey.translations[1].name = itemEn ? itemEn.name : ''
    } else {
      this.setInitialValue()
    }
  }
}
